<div class="container-fluid bookings-calendar py-3">
  <div class="row g-3">

    <!-- ANCHOR TOOLBAR -->
    <div class="col-12">
      <div class="calendar-toolbar d-flex flex-wrap align-items-center gap-2">

        <button
          type="button"
          class="btn btn-sm btn-outline-calendar"
          (click)="goToday()">
          Hoy
        </button>

        <div class="btn-group" role="group" aria-label="Navegar periodo">
          <button
            type="button"
            class="btn btn-sm btn-outline-calendar"
            aria-label="Periodo anterior"
            ngbTooltip="Periodo anterior"
            (click)="goPrevious()">
            <i class="material-icons">chevron_left</i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-calendar"
            aria-label="Periodo siguiente"
            ngbTooltip="Periodo siguiente"
            (click)="goNext()">
            <i class="material-icons">chevron_right</i>
          </button>
        </div>

        <h5 class="calendar-title mb-0 text-truncate">
          {{ periodTitle }}
        </h5>

        <span class="visually-hidden" aria-live="polite">
          {{ periodTitle }}, {{ visibleEventsCount }} reservaciones visibles
        </span>

        <div class="flex-grow-1"></div>

        <div class="btn-group view-switch" role="group" aria-label="Cambiar vista del calendario">
          <button
            type="button"
            class="btn btn-sm"
            [class.is-selected]="viewMode === 'day'"
            [attr.aria-pressed]="viewMode === 'day'"
            (click)="setViewMode('day')">
            Día
          </button>
          <button
            type="button"
            class="btn btn-sm"
            [class.is-selected]="viewMode === 'week'"
            [attr.aria-pressed]="viewMode === 'week'"
            (click)="setViewMode('week')">
            Semana
          </button>
          <button
            type="button"
            class="btn btn-sm"
            [class.is-selected]="viewMode === 'month'"
            [attr.aria-pressed]="viewMode === 'month'"
            (click)="setViewMode('month')">
            Mes
          </button>
        </div>

        <button
          type="button"
          class="btn btn-sm btn-success btn-create d-flex align-items-center gap-1"
          aria-label="Nueva reservación"
          (click)="openAmenitySelector()">
          <i class="material-icons">add</i>
          <span class="d-none d-xl-inline">Nueva reservación</span>
        </button>

        <button
          type="button"
          class="btn btn-sm btn-outline-calendar"
          aria-label="Actualizar reservaciones"
          ngbTooltip="Actualizar"
          (click)="refresh()">
          <i class="material-icons">refresh</i>
        </button>

      </div>
    </div>

    <!-- ANCHOR LEYENDA -->
    <div class="col-12">
      <div class="calendar-legend d-flex flex-wrap align-items-center gap-3">
        <span class="legend-title">Estados</span>
        @for (stateFilter of stateFilters; track stateFilter.state) {
          <button
            type="button"
            class="legend-toggle d-inline-flex align-items-center gap-2"
            [class.is-off]="!stateFilter.visible"
            [attr.aria-pressed]="stateFilter.visible"
            (click)="toggleState(stateFilter)">
            <span class="legend-swatch" [ngClass]="stateFilter.stateClass"></span>
            {{ stateFilter.label }}
          </button>
        }
        <span class="legend-item d-inline-flex align-items-center gap-2">
          <span class="legend-swatch is-now"></span>
          Hora actual
        </span>
      </div>
    </div>

    <!-- ANCHOR AMENIDADES -->
    <div class="col-12 col-lg-3 col-xxl-2">
      <div class="calendar-panel amenity-panel h-100">

        <div class="panel-title">
          Amenidades
        </div>

        <div class="panel-actions d-flex align-items-center gap-2">
          <button
            type="button"
            class="btn-panel-action flex-fill text-truncate"
            (click)="showAllAmenities()">
            Mostrar todas
          </button>
          <button
            type="button"
            class="btn-panel-action flex-fill text-truncate"
            (click)="hideAllAmenities()">
            Ocultar todas
          </button>
        </div>

        <div class="amenity-list d-flex flex-row flex-lg-column gap-2">
          @for (amenityFilter of amenityFilters; track amenityFilter.amenityId) {
            <button
              type="button"
              class="amenity-chip d-flex align-items-center gap-2"
              [class.is-off]="!amenityFilter.visible"
              [attr.aria-pressed]="amenityFilter.visible"
              (click)="toggleAmenity(amenityFilter)">
              <span
                class="amenity-dot flex-shrink-0"
                [ngStyle]="{
                  'background-color': amenityFilter.visible ? amenityFilter.color.border : 'transparent',
                  'border-color': amenityFilter.color.border
                }">
              </span>
              <span class="amenity-name text-truncate">
                {{ amenityFilter.name }}
              </span>
            </button>
          } @empty {
            <span class="amenity-empty">
              Sin amenidades
            </span>
          }
        </div>

      </div>
    </div>

    <!-- ANCHOR REJILLA -->
    <div class="col-12 col-lg-9 col-xxl-10">
      <div class="calendar-panel grid-panel">

        @if (!loading && visibleEventsCount === 0) {
          <div class="calendar-empty text-center">
            @if (filterHidesEverything) {
              Todas las reservaciones de este periodo están ocultas por los filtros activos
            } @else {
              No hay reservaciones en este periodo
            }
          </div>
        }

        <!-- ANCHOR VISTA MES -->
        @if (viewMode === 'month') {

          <div class="month-weekdays">
            @for (weekdayLabel of weekdayLabels; track weekdayLabel) {
              <div class="month-weekday text-center text-truncate">
                {{ weekdayLabel }}
              </div>
            }
          </div>

          @for (week of monthWeeks; track week.weekKey) {
            <div class="month-week">
              @for (day of week.days; track day.dateKey) {
                <div
                  class="month-cell d-flex flex-column"
                  [class.is-outside]="!day.isCurrentMonth">

                  <button
                    type="button"
                    class="month-day-number align-self-center"
                    [class.is-today]="day.isToday"
                    [attr.aria-label]="'Ver ' + day.longLabel"
                    (click)="openDay(day.dateKey)">
                    {{ day.dayNumber }}
                  </button>

                  <div class="month-cell-body">
                    @if (loading) {
                      <p-skeleton height="16px" borderRadius="6px" styleClass="mb-1"></p-skeleton>
                      <p-skeleton height="16px" borderRadius="6px" styleClass="mb-1"></p-skeleton>
                    } @else {
                      @for (event of day.previewEvents; track event.bookingId) {
                        <button
                          type="button"
                          class="month-event d-flex align-items-center gap-1"
                          [ngClass]="event.stateClass"
                          [ngStyle]="{
                            'background-color': event.backgroundColor,
                            'color': event.textColor
                          }"
                          [attr.aria-label]="event.ariaLabel"
                          (click)="openEvent(event)">
                          <span
                            class="month-event-dot flex-shrink-0"
                            [ngStyle]="{ 'background-color': event.borderColor }">
                          </span>
                          <span class="month-event-hour flex-shrink-0">
                            {{ event.startLabel }}
                          </span>
                          <span class="month-event-name text-truncate d-none d-md-inline">
                            {{ event.amenityName }}
                          </span>
                        </button>
                      }

                      @if (day.moreCount > 0) {
                        <button
                          type="button"
                          class="month-more"
                          [attr.aria-label]="'Ver las ' + day.events.length + ' reservaciones de ' + day.longLabel"
                          (click)="openDay(day.dateKey)">
                          +{{ day.moreCount }} más
                        </button>
                      }
                    }
                  </div>

                </div>
              }
            </div>
          }

        }

        <!-- ANCHOR VISTA DIA / SEMANA -->
        @if (viewMode !== 'month') {

          <div class="time-grid-scroll" #timeGridScroll>

            <div class="time-grid-header d-flex">
              <div class="time-gutter flex-shrink-0"></div>
              <div class="d-flex flex-grow-1 min-w-0">
                @for (day of timeDays; track day.dateKey) {
                  <div class="day-header flex-fill min-w-0" [class.is-today]="day.isToday">
                    <button
                      type="button"
                      class="day-header-button w-100 text-center"
                      [attr.aria-label]="'Ver ' + day.longLabel"
                      (click)="openDay(day.dateKey)">
                      <span class="day-header-weekday d-block text-truncate">
                        {{ day.weekdayLabel }}
                      </span>
                      <span class="day-header-number" [class.is-today]="day.isToday">
                        {{ day.dayNumber }}
                      </span>
                    </button>
                  </div>
                }
              </div>
            </div>

            <div class="time-grid d-flex" [ngStyle]="{ 'height.px': hourHeightPx * 24 }">

              <div class="time-gutter flex-shrink-0">
                @for (hourSlot of hourSlots; track hourSlot.hour) {
                  <div class="time-gutter-cell" [ngStyle]="{ 'height.px': hourHeightPx }">
                    <span class="time-gutter-label">{{ hourSlot.label }}</span>
                  </div>
                }
              </div>

              <div class="d-flex flex-grow-1 min-w-0">
                @for (day of timeDays; track day.dateKey) {
                  <div class="day-column flex-fill min-w-0" [class.is-today]="day.isToday">

                    @for (hourSlot of hourSlots; track hourSlot.hour) {
                      <div class="hour-cell" [ngStyle]="{ 'height.px': hourHeightPx }"></div>
                    }

                    @if (loading) {
                      @for (skeletonSlot of skeletonSlots; track skeletonSlot.key) {
                        <div
                          class="event-skeleton"
                          [ngStyle]="{
                            'top.px': skeletonSlot.topPx,
                            'height.px': skeletonSlot.heightPx
                          }">
                          <p-skeleton width="100%" height="100%" borderRadius="8px"></p-skeleton>
                        </div>
                      }
                    } @else {
                      @for (event of day.events; track event.bookingId) {
                        <button
                          type="button"
                          class="time-event d-flex flex-column"
                          [ngClass]="event.stateClass"
                          [ngStyle]="{
                            'background-color': event.backgroundColor,
                            'border-left-color': event.borderColor,
                            'color': event.textColor,
                            'top.px': event.topPx,
                            'height.px': event.heightPx,
                            'left.%': event.leftPercent,
                            'width.%': event.widthPercent
                          }"
                          [attr.aria-label]="event.ariaLabel"
                          (click)="openEvent(event)">

                          <span class="time-event-title text-truncate">
                            {{ event.amenityName }}
                          </span>

                          <span class="time-event-hour text-truncate">
                            {{ event.timeRangeLabel }}
                          </span>

                          @if (viewMode === 'day') {
                            <span class="time-event-detail text-truncate">
                              {{ event.streetName }} {{ event.houseNumber }}
                            </span>
                            <span class="time-event-detail text-truncate">
                              {{ event.guests }} invitados
                            </span>
                          }

                          @if (event.state === 'cancelled') {
                            <span class="time-event-state">Cancelada</span>
                          }

                          @if (event.isBlocked) {
                            <span class="time-event-state">Reservación total</span>
                          }

                        </button>
                      }
                    }

                    @if (day.isToday) {
                      <div class="now-line" [ngStyle]="{ 'top.px': nowTopPx }">
                        <span class="now-dot"></span>
                      </div>
                    }

                  </div>
                }
              </div>

            </div>
          </div>

        }

      </div>
    </div>

  </div>
</div>
